import Link from "next/link"

import { WHATSAPP_SUPPORT_URL } from "@/lib/support"

export function AuthFooter() {
  return (
    <footer className="py-6 text-center">
      <div className="text-body-sm flex items-center justify-center gap-4 text-text-500">
        <Link href="/termos" className="transition-colors hover:text-text-700">
          Termos de Uso
        </Link>
        <span className="text-text-300">|</span>
        <Link
          href="/privacidade"
          className="transition-colors hover:text-text-700"
        >
          Privacidade
        </Link>
        <span className="text-text-300">|</span>
        <a
          href={WHATSAPP_SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="transition-colors hover:text-text-700"
        >
          Contato
        </a>
      </div>
    </footer>
  )
}
